<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center mb-3">
    <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
      <mat-label>Serviço Adicional</mat-label>
      <input matInput formControlName="serviceAdditional" readonly />
      @if (this.form.get('serviceAdditional')!.enabled) {
        <button mat-icon-button matSuffix (click)="addAdditionalService()">
          <mat-icon>add</mat-icon>
        </button>
      }
    </mat-form-field>
    <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
      <mat-label>Valor Serviço Adicional</mat-label>
      @if (form.get('serviceAdditionalPrice')!.value != '') {
        <span matTextPrefix>R$&nbsp;</span>
      }
      <input matInput formControlName="serviceAdditionalPrice" currencyInput />
    </mat-form-field>
  </div>
  <div class="flex justify-between gap-4 items-center mb-3">
    <mat-form-field
      class="input-tg w-2/12 px-2 no-message-new"
      appearance="outline"
    >
      <mat-label>Data</mat-label>
      <input
        matInput
        [matDatepicker]="date"
        (focus)="openDatepicker()"
        formControlName="date"
        readonly
      />
      <mat-datepicker-toggle matIconSuffix [for]="date"></mat-datepicker-toggle>
      <mat-datepicker #date></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg w-2/12 px-2 no-message-new"
      appearance="outline"
    >
      <mat-label>Valor unitário</mat-label>
      @if (form.get('priceUnit')!.value != '') {
        <span matTextPrefix>R$&nbsp;</span>
      }
      <input
        matInput
        formControlName="priceUnit"
        currencyInput
        (blur)="calculateTotal()"
      />
    </mat-form-field>

    <mat-form-field
      class="input-tg w-2/12 px-2 no-message-new"
      appearance="outline"
    >
      <mat-label>Quantidade</mat-label>
      <input
        matInput
        formControlName="amount"
        integerInput
        (blur)="calculateTotal()"
      />
    </mat-form-field>

    <mat-form-field
      class="input-tg w-2/12 px-2 no-message-new"
      appearance="outline"
    >
      <mat-label>Taxa</mat-label>
      @if (form.get('tax')!.value != '') {
        <span matTextSuffix>%&nbsp;</span>
      }
      <input
        matInput
        formControlName="tax"
        currencyInput
        (blur)="calculateTotal()"
      />
    </mat-form-field>

    <mat-form-field
      class="input-tg w-2/12 px-2 no-message-new"
      appearance="outline"
    >
      <mat-label>Valor total</mat-label>
      @if (form.get('priceTotal')!.value != '') {
        <span matTextPrefix>R$&nbsp;</span>
      }
      <input matInput formControlName="priceTotal" currencyInput />
    </mat-form-field>

    <button
      mat-flat-button
      class="btn-tg w-1/12 no-message-new"
      (click)="cancel()"
    >
      Cancel
    </button>
    @if (this.checkEdit()) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editAddress()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createAddress()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
